export default {
    mounted(el, binding) {
        el.classList.add('reveal')

        if (binding.value) {
            el.classList.add(`reveal--${binding.value}`)
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    el.classList.add('is-revealed')
                    observer.unobserve(el)
                }
            },
            {
                threshold: 0.15,
            }
        )

        observer.observe(el)

        el._revealObserver = observer
    },

    unmounted(el) {
        el._revealObserver?.disconnect()
    },
}